// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results{
	padding: 2.4em 0 8.4375em;
	position: relative;
}
.results__text{
	text-align: center;
	font-size: 0.875em;
	line-height: 1.214;
	padding: 0 1.6em;
	margin-bottom: 1.6em;
}
.results__emos{
	position: relative;
	width: 100%;
	height: 11.85em;
}
.results__emos svg{
	position: absolute;
	height: auto;
	width: 4.6875em;
	top: 0;
	left: 50%;
}
.results__emos svg:nth-child(1){
	transform: rotate(-21.54deg);
	margin-top: 2.6em;
    margin-left: -9.7em;
}
.results__emos svg:nth-child(2){
	transform: rotate(5.74deg);
	margin-top: 4.9em;
    margin-left: -5.9em;
}
.results__emos svg:nth-child(3){
	transform: rotate(9.16deg);
	margin-top: 0.3em;
    margin-left: -2.6em;
}
.results__emos svg:nth-child(4){
	transform: rotate(-20.25deg);
	margin-top: 4.7em;
    margin-left: 1.7em;
}
.results__emos svg:nth-child(5){
	transform: rotate(9.16deg);
    margin-top: 2.5em;
    margin-left: 5.3em;
}
.results__right{
	position: relative;
}
.results__wrapper{ 
	width: 100%; 
	margin: 0 auto; 
	display: flex;
	justify-content: center;
	align-items: center; 
}
.results .swiper-container{
	width: 100%;
	display: flex;
	justify-content: center;
	cursor: pointer; 
	padding: 0 2.38em 0 2.85em;
}
.results .results__wrapper .swiper-container .swiper-wrapper{
	display: flex;
	justify-content: flex-start;
}
.results .results__wrapper .swiper-container .swiper-wrapper .swiper-slide{
	padding: 0 0.625em;
}
.results__slide{
	height: 13.953125em;	
	background: #161617;
	position: relative;
	border-radius: 0.625em;
	margin-bottom: 0.95em; 
	display: flex;
	flex-direction: column;
	color: #fff;
}
.results__slideTop{
	height: 2.56em;
    padding: 0.4em 0.7em 0;
}
.tips__topLeft{
    display: flex;
    align-items: center;
}
.tips__topAva{
    width: 1.45em;
    margin-right: 0.45em;
}
.tips__topHead{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.tips__topName{
	font-family: 'SF Pro Display';
    font-weight: 600;
    font-size: 0.544em;
    line-height: 1.666;  
    position: relative;
    letter-spacing: 0.019166em;
}
.tips__topName svg{
    height: auto;
    width: 1.3em;
    position: absolute;
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    margin-left: 0.45em;
}
.tips__topSubs{
	font-family: 'Yandex Sans';
    color: rgba(255, 255, 255, 0.45);
    line-height: 1.23;
    font-size: 0.5em;  
    margin-top: 0.4em;
}
.results__slideMiddle{
	flex-grow: 1;
	position: relative; 
	overflow: hidden;
}
.results__slideImage{
	position: absolute;
	left: 0;
	top: 0;
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.results__slideMiddleMute{
	position: absolute;
	width: 1em;
	height: 1em;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;
	background: rgba(0, 0, 0, 0.55);
	bottom: 0.45em;
	left: 0.45em;
}
.results__slideMiddleTime{
	font-weight: 500;
    font-size: 0.75em;
    line-height: 1.23;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 3.5em;
    position: absolute;
    bottom: 0.45em;
    right: 0.45em;
    padding: 0 0.35em;
}
.results__slideMiddleMute svg{
	width: 81.25%;
	height: auto;
}
.results__slideMiddlePlay{
	position: absolute;
	left: 50%;
	top: 50%;
	width: 1.5em;
	height: auto;
	margin: -0.95em 0 0 -0.75em;
}
.results__slideBottom{
	height: 1.79125em; 
	display: flex;
    align-items: center;
    padding: 0em 0.8em 0.2em;
}
.results__slideBottomText{
	font-weight: 500;
	line-height: 1;
	font-size: 0.591em;
	letter-spacing: 0.02em;
}
.results .swiper-container-horizontal>.swiper-pagination-bullets{
	bottom: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}
.results .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
	width: 0.1875em;
	height: 0.1875em;
	background: #D9D9D9; 
	border-radius: 100%;
	display: block;
	opacity: 0.5;
	margin: 0 0.1875em; 	
}
.results .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet.swiper-pagination-bullet-active{
	opacity: 1;
}
.swiperArrow{
	display: none;
}
.results__bottomWrapper{
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2em;
}
.results__teacher{
	width: 4.93em;
	margin-left: 0.5em;
	margin-bottom: 1.3em;
} 
.resultsBottom__leftText{ 
	text-align: center;
	margin: 0 auto 1.2em;
	font-size: 0.875em;
	line-height: 1.214;
	max-width: 18.5em;  
}
.resultsBottom__btns{
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 14.9375em;
	margin: 0 auto;
	padding-left: 0.25em;
}
.resultsBottom__btns .btn{
	height: 2.25em;
}
.resultsBottom__btns .btn>span{
	font-size: 0.75em;
	font-family: 'SF Pro Display';
    font-weight: 600;
    font-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on;
    letter-spacing: 0.037em;
}
.resultsBottom__btns .btn>span span{
	display: none;
}
.resultsBottom__btn--left{
	width: 5.3125em;
}
.resultsBottom__btn--right{
	width: 8.75em;
	background: transparent;
	border: max(1.2px,0.075em) solid #FFFFFF;
} 
.results__social{
	width: 100%;
	position: absolute;
	left: 0;
	bottom: 2.6em;
}
.resultsBottom__rightText{
	text-align: center;
	font-size: 0.75em;
	line-height: 1.33;
	margin-bottom: 1em;
	font-family: 'SF Pro Display';
	letter-spacing: 0.06em;
	font-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on;
}
.social{
	display: flex;
	justify-content: center;
	align-items: center;
}
.social__link{
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 0.21875em;
}
.social__link svg{
	width: 2.3125em;
	height: auto;
}
@media(min-width: 100vh){ 
	.results{
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
	}
	.results__left{
		width: 42.1%;
    	margin-top: 6.8em;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	.results__right{
		margin-top: 6.75em;
		width: 47.25%; 
	}
	.results__text{
		padding: 0;
		font-size: 1.125em; 
		line-height: 1.38;
		max-width: 35.6em;
	    margin-right: -0.6em;
	    margin-bottom: 1.35em;
	}
	.results__emos{ 
	    max-width: 40em;
	    height: 28em;
	}
	.results__emos svg{
		width: 11.25em;
	}
	.results__emos svg:nth-child(1){ 
	    margin-top: 8.7em;
	    margin-left: -18.2em;
	}
	.results__emos svg:nth-child(2){ 
	    margin-top: 14.7em;
	    margin-left: -10.8em;
	}
	.results__emos svg:nth-child(3){ 
	    margin-top: 1.3em;
	    margin-left: -8.3em;
	}
	.results__emos svg:nth-child(4){ 
	    margin-top: 12.9em;
	    margin-left: 2.6em;
	}
	.results__emos svg:nth-child(5){ 
	    margin-top: 5.4em;
	    margin-left: 8.4em;
	}
	.results__wrapper{  
		width: 141.3em;
		margin: 0;
		padding-bottom: 0.125em;
	}
	.results .swiper-container{
		padding: 0 93.375em 0 0;
	}
	.results .results__wrapper .swiper-container .swiper-wrapper{
		transform: none !important;
	}
	.results .results__wrapper .swiper-container .swiper-wrapper .swiper-slide{
		width: 100%;
	    padding: 0 16.5% 0 0;
	}
	.results__slide{
		height: 28.5em;
		margin-bottom: 2.6em;
		border-radius: 1em;
	}
	.swiper-slide{
		transition: 0.3s !important;
		opacity: 0.6; 
		z-index: 0;
		pointer-events: none; 
	} 
	.swiper-slide-active{
		z-index: 2;
		opacity: 1;
		transform: none;
		pointer-events: all;
	}
	.swiper-slide-prev:nth-child(2),
	.swiper-slide-active:nth-child(2)+.swiper-slide,
	.swiper-slide-active:nth-child(2){
		transform: translateX(-100%);
	}
	.swiper-slide-active:nth-child(3){
		transform: translateX(-200%);
	}
	.results__slideTop{
		height: 3em;
		padding: 0.2em 0.8em 0;
	}
	.tips__topAva{
		width: 1.5em;
	    margin-right: 0.5em;
	}
	.tips__topName{
		letter-spacing: 0.03em;
		font-size: 0.9375em;
	}
	.tips__topName svg{
		display: none;
	}
	.tips__topSubs{
		font-size: 0.8125em;
		margin-top: -0.1em;
	}
	.results__slideMiddleTime{
		font-size: 0.75em;
		line-height: 1.66;
		bottom: 0.85em;
	    right: 0.85em;
	    padding: 0 0.85em;
	}
	.results__slideMiddleMute{
	    bottom: 0.85em;
    	left: 0.85em;
    	width: 1.25em;
    	height: 1.25em;
	}
	.results__slideMiddlePlay{
		width: 3.75em;
		margin: -1.875em 0 0 -1.975em;
		transition: 0.3s transform;
	}
	.results__slide:hover .results__slideMiddlePlay{
		transform: scale(1.1);
	}
	.results__slideBottom{
		height: 3em; 
		padding: 0em 1em 0.9em;
	}
	.results__slideBottomText{
		font-size: 1em;
		letter-spacing: 0;
	}
	.swiperArrow{
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0;
		border: none;
		margin: 0;
		background: #fff;
		position: absolute;
		left: 0;
		top: 12.2em;
		z-index: 33;
		transition: 0.3s background;
		width: 4.3125em;
		height: 4.3125em;
		border-radius: 100%;
	}	
	.swiperArrow svg{
		height: auto;
		width: 2.0625em;
	}
	.swiperArrow:hover{
		background: #9290FF;
	}
	.swiperArrow path{
		transition: 0.3s fill;
	}
	.swiperArrow:hover path{
		fill: #fff;
	}
	.swiper-prev{
		margin-left: -5.45em;
	}
	.swiper-next{
		margin-left: 41.3em;
	}
	.results .swiper-container-horizontal>.swiper-pagination-bullets{
		width: 40em;
	    bottom: 0.8em;
	}
	.results .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
		background: #fff;
		opacity: 0.4;
		width: 0.51375em;
		height: 0.51375em;
		margin: 0 0.61625em;
	} 
	.results__bottomWrapper{
		flex-direction: row;
		margin-top: 2.3em;
	}
	.results__teacher{
		width: 7.5em;
		margin: 0 1.85em 0 -0.3em;
	}
	.resultsBottom__leftText{
		font-family: 'Roboto';
		letter-spacing: 0; 
		padding: 0;
		margin: -0.65em 0 1.1em 0.1em;
		font-size: 1.125em;
		line-height: 1.38;  
		max-width: 33em;
		text-align: left;
	}
	.resultsBottom__leftText span{
		display: block;
	}
	.resultsBottom__btns{
		margin: 0;
		padding: 0;
		width: 27.3em;
	}
	.resultsBottom__btns .btn{
		height: 3em;
	}
	.resultsBottom__btn--left{
		width: 15.6875em;
	}
	.resultsBottom__btn--right{
		width: 11em;
		transition: 0.3s background, 0.3s border-color, 0.3s color;
	}
	.resultsBottom__btn--right:hover{
		background: #FF5317;
		border-color: #FF5317;
	}
	.resultsBottom__btns .btn span{
		font-size: 1em;
	}
	.resultsBottom__btns .btn>span span{
		display: inline;
	}
	.results__social{
		position: static;
		max-width: 38.7em;
	}
	.resultsBottom__rightText{
		font-family: 'Roboto';
		letter-spacing: 0; 
		margin: 0 0 1.25em;
		font-size: 1em;
		line-height: 1.1875; 
	}
	.social{
		padding-right: 0.4em;
	}
	.social__link{
		transition: 0.3s transform;
		margin: 0 0 0 0.4375em;
	}
	.social__link:hover{
		transform: scale(1.1);
	}
}
@media(min-width: 100vh) and (max-width: 145vh){ 
	.results{
		font-size: 1.0191vw;
		height: 100%;
	    align-items: center;
	    padding: 0 0 9em;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/Results/results.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;AACrB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,MAAM;CACN,SAAS;AACV;AACA;CACC,4BAA4B;CAC5B,iBAAiB;IACd,mBAAmB;AACvB;AACA;CACC,0BAA0B;CAC1B,iBAAiB;IACd,mBAAmB;AACvB;AACA;CACC,0BAA0B;CAC1B,iBAAiB;IACd,mBAAmB;AACvB;AACA;CACC,4BAA4B;CAC5B,iBAAiB;IACd,kBAAkB;AACtB;AACA;CACC,0BAA0B;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,eAAe;CACf,0BAA0B;AAC3B;AACA;CACC,aAAa;CACb,2BAA2B;AAC5B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;CAClB,sBAAsB;CACtB,qBAAqB;CACrB,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,cAAc;IACX,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;CACC,6BAA6B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;CACC,0BAA0B;IACvB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,cAAc;CACd,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CACnB,+BAA+B;CAC/B,cAAc;CACd,YAAY;AACb;AACA;CACC,gBAAgB;IACb,iBAAiB;IACjB,iBAAiB;IACjB,+BAA+B;IAC/B,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;AACA;CACC,aAAa;CACb,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ,2BAA2B;AAC5B;AACA;CACC,iBAAiB;CACjB,aAAa;IACV,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,sBAAsB;AACvB;AACA;CACC,SAAS;IACN,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;CACd,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,UAAU;AACX;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;CACjB,6BAA6B;IAC1B,gBAAgB;IAChB,sDAAsD;IACtD,uBAAuB;AAC3B;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,wCAAwC;AACzC;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,6BAA6B;CAC7B,sBAAsB;CACtB,sDAAsD;AACvD;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,YAAY;AACb;AACA;CACC;EACC,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;CAClB;CACA;EACC,YAAY;KACT,iBAAiB;EACpB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;CACtB;CACA;EACC,kBAAkB;EAClB,aAAa;CACd;CACA;EACC,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;KACd,oBAAoB;KACpB,qBAAqB;CACzB;CACA;KACI,eAAe;KACf,YAAY;CAChB;CACA;EACC,cAAc;CACf;CACA;KACI,iBAAiB;KACjB,oBAAoB;CACxB;CACA;KACI,kBAAkB;KAClB,oBAAoB;CACxB;CACA;KACI,iBAAiB;KACjB,mBAAmB;CACvB;CACA;KACI,kBAAkB;KAClB,kBAAkB;CACtB;CACA;KACI,iBAAiB;KACjB,kBAAkB;CACtB;CACA;EACC,cAAc;EACd,SAAS;EACT,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,WAAW;KACR,oBAAoB;CACxB;CACA;EACC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;CACnB;CACA;EACC,2BAA2B;EAC3B,YAAY;EACZ,UAAU;EACV,oBAAoB;CACrB;CACA;EACC,UAAU;EACV,UAAU;EACV,eAAe;EACf,mBAAmB;CACpB;CACA;;;EAGC,4BAA4B;CAC7B;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,WAAW;EACX,sBAAsB;CACvB;CACA;EACC,YAAY;KACT,mBAAmB;CACvB;CACA;EACC,sBAAsB;EACtB,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;KACX,aAAa;KACb,iBAAiB;CACrB;CACA;KACI,cAAc;KACd,YAAY;KACZ,aAAa;KACb,cAAc;CAClB;CACA;EACC,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;CAC3B;CACA;EACC,qBAAqB;CACtB;CACA;EACC,WAAW;EACX,sBAAsB;CACvB;CACA;EACC,cAAc;EACd,iBAAiB;CAClB;CACA;EACC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;CACpB;CACA;EACC,YAAY;EACZ,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,UAAU;CACX;CACA;EACC,oBAAoB;CACrB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,WAAW;KACR,aAAa;CACjB;CACA;EACC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;CACpB;CACA;EACC,mBAAmB;EACnB,iBAAiB;CAClB;CACA;EACC,YAAY;EACZ,yBAAyB;CAC1B;CACA;EACC,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,cAAc;CACf;CACA;EACC,SAAS;EACT,UAAU;EACV,aAAa;CACd;CACA;EACC,WAAW;CACZ;CACA;EACC,gBAAgB;CACjB;CACA;EACC,WAAW;EACX,0DAA0D;CAC3D;CACA;EACC,mBAAmB;EACnB,qBAAqB;CACtB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,0BAA0B;EAC1B,sBAAsB;CACvB;CACA;EACC,qBAAqB;CACtB;AACD;AACA;CACC;EACC,mBAAmB;EACnB,YAAY;KACT,mBAAmB;KACnB,gBAAgB;CACpB;AACD","sourcesContent":[".results{\n\tpadding: 2.4em 0 8.4375em;\n\tposition: relative;\n}\n.results__text{\n\ttext-align: center;\n\tfont-size: 0.875em;\n\tline-height: 1.214;\n\tpadding: 0 1.6em;\n\tmargin-bottom: 1.6em;\n}\n.results__emos{\n\tposition: relative;\n\twidth: 100%;\n\theight: 11.85em;\n}\n.results__emos svg{\n\tposition: absolute;\n\theight: auto;\n\twidth: 4.6875em;\n\ttop: 0;\n\tleft: 50%;\n}\n.results__emos svg:nth-child(1){\n\ttransform: rotate(-21.54deg);\n\tmargin-top: 2.6em;\n    margin-left: -9.7em;\n}\n.results__emos svg:nth-child(2){\n\ttransform: rotate(5.74deg);\n\tmargin-top: 4.9em;\n    margin-left: -5.9em;\n}\n.results__emos svg:nth-child(3){\n\ttransform: rotate(9.16deg);\n\tmargin-top: 0.3em;\n    margin-left: -2.6em;\n}\n.results__emos svg:nth-child(4){\n\ttransform: rotate(-20.25deg);\n\tmargin-top: 4.7em;\n    margin-left: 1.7em;\n}\n.results__emos svg:nth-child(5){\n\ttransform: rotate(9.16deg);\n    margin-top: 2.5em;\n    margin-left: 5.3em;\n}\n.results__right{\n\tposition: relative;\n}\n.results__wrapper{ \n\twidth: 100%; \n\tmargin: 0 auto; \n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center; \n}\n.results .swiper-container{\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tcursor: pointer; \n\tpadding: 0 2.38em 0 2.85em;\n}\n.results .results__wrapper .swiper-container .swiper-wrapper{\n\tdisplay: flex;\n\tjustify-content: flex-start;\n}\n.results .results__wrapper .swiper-container .swiper-wrapper .swiper-slide{\n\tpadding: 0 0.625em;\n}\n.results__slide{\n\theight: 13.953125em;\t\n\tbackground: #161617;\n\tposition: relative;\n\tborder-radius: 0.625em;\n\tmargin-bottom: 0.95em; \n\tdisplay: flex;\n\tflex-direction: column;\n\tcolor: #fff;\n}\n.results__slideTop{\n\theight: 2.56em;\n    padding: 0.4em 0.7em 0;\n}\n.tips__topLeft{\n    display: flex;\n    align-items: center;\n}\n.tips__topAva{\n    width: 1.45em;\n    margin-right: 0.45em;\n}\n.tips__topHead{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n.tips__topName{\n\tfont-family: 'SF Pro Display';\n    font-weight: 600;\n    font-size: 0.544em;\n    line-height: 1.666;  \n    position: relative;\n    letter-spacing: 0.019166em;\n}\n.tips__topName svg{\n    height: auto;\n    width: 1.3em;\n    position: absolute;\n    top: 50%;\n    left: 100%;\n    transform: translateY(-50%);\n    margin-left: 0.45em;\n}\n.tips__topSubs{\n\tfont-family: 'Yandex Sans';\n    color: rgba(255, 255, 255, 0.45);\n    line-height: 1.23;\n    font-size: 0.5em;  \n    margin-top: 0.4em;\n}\n.results__slideMiddle{\n\tflex-grow: 1;\n\tposition: relative; \n\toverflow: hidden;\n}\n.results__slideImage{\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n.results__slideMiddleMute{\n\tposition: absolute;\n\twidth: 1em;\n\theight: 1em;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 100%;\n\tbackground: rgba(0, 0, 0, 0.55);\n\tbottom: 0.45em;\n\tleft: 0.45em;\n}\n.results__slideMiddleTime{\n\tfont-weight: 500;\n    font-size: 0.75em;\n    line-height: 1.23;\n    background: rgba(0, 0, 0, 0.55);\n    border-radius: 3.5em;\n    position: absolute;\n    bottom: 0.45em;\n    right: 0.45em;\n    padding: 0 0.35em;\n}\n.results__slideMiddleMute svg{\n\twidth: 81.25%;\n\theight: auto;\n}\n.results__slideMiddlePlay{\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\twidth: 1.5em;\n\theight: auto;\n\tmargin: -0.95em 0 0 -0.75em;\n}\n.results__slideBottom{\n\theight: 1.79125em; \n\tdisplay: flex;\n    align-items: center;\n    padding: 0em 0.8em 0.2em;\n}\n.results__slideBottomText{\n\tfont-weight: 500;\n\tline-height: 1;\n\tfont-size: 0.591em;\n\tletter-spacing: 0.02em;\n}\n.results .swiper-container-horizontal>.swiper-pagination-bullets{\n\tbottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n}\n.results .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{\n\twidth: 0.1875em;\n\theight: 0.1875em;\n\tbackground: #D9D9D9; \n\tborder-radius: 100%;\n\tdisplay: block;\n\topacity: 0.5;\n\tmargin: 0 0.1875em; \t\n}\n.results .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet.swiper-pagination-bullet-active{\n\topacity: 1;\n}\n.swiperArrow{\n\tdisplay: none;\n}\n.results__bottomWrapper{\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmargin-top: 2em;\n}\n.results__teacher{\n\twidth: 4.93em;\n\tmargin-left: 0.5em;\n\tmargin-bottom: 1.3em;\n} \n.resultsBottom__leftText{ \n\ttext-align: center;\n\tmargin: 0 auto 1.2em;\n\tfont-size: 0.875em;\n\tline-height: 1.214;\n\tmax-width: 18.5em;  \n}\n.resultsBottom__btns{\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 14.9375em;\n\tmargin: 0 auto;\n\tpadding-left: 0.25em;\n}\n.resultsBottom__btns .btn{\n\theight: 2.25em;\n}\n.resultsBottom__btns .btn>span{\n\tfont-size: 0.75em;\n\tfont-family: 'SF Pro Display';\n    font-weight: 600;\n    font-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on;\n    letter-spacing: 0.037em;\n}\n.resultsBottom__btns .btn>span span{\n\tdisplay: none;\n}\n.resultsBottom__btn--left{\n\twidth: 5.3125em;\n}\n.resultsBottom__btn--right{\n\twidth: 8.75em;\n\tbackground: transparent;\n\tborder: max(1.2px,0.075em) solid #FFFFFF;\n} \n.results__social{\n\twidth: 100%;\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 2.6em;\n}\n.resultsBottom__rightText{\n\ttext-align: center;\n\tfont-size: 0.75em;\n\tline-height: 1.33;\n\tmargin-bottom: 1em;\n\tfont-family: 'SF Pro Display';\n\tletter-spacing: 0.06em;\n\tfont-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on;\n}\n.social{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.social__link{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin: 0 0.21875em;\n}\n.social__link svg{\n\twidth: 2.3125em;\n\theight: auto;\n}\n@media(min-width: 100vh){ \n\t.results{\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding-bottom: 0;\n\t}\n\t.results__left{\n\t\twidth: 42.1%;\n    \tmargin-top: 6.8em;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\t}\n\t.results__right{\n\t\tmargin-top: 6.75em;\n\t\twidth: 47.25%; \n\t}\n\t.results__text{\n\t\tpadding: 0;\n\t\tfont-size: 1.125em; \n\t\tline-height: 1.38;\n\t\tmax-width: 35.6em;\n\t    margin-right: -0.6em;\n\t    margin-bottom: 1.35em;\n\t}\n\t.results__emos{ \n\t    max-width: 40em;\n\t    height: 28em;\n\t}\n\t.results__emos svg{\n\t\twidth: 11.25em;\n\t}\n\t.results__emos svg:nth-child(1){ \n\t    margin-top: 8.7em;\n\t    margin-left: -18.2em;\n\t}\n\t.results__emos svg:nth-child(2){ \n\t    margin-top: 14.7em;\n\t    margin-left: -10.8em;\n\t}\n\t.results__emos svg:nth-child(3){ \n\t    margin-top: 1.3em;\n\t    margin-left: -8.3em;\n\t}\n\t.results__emos svg:nth-child(4){ \n\t    margin-top: 12.9em;\n\t    margin-left: 2.6em;\n\t}\n\t.results__emos svg:nth-child(5){ \n\t    margin-top: 5.4em;\n\t    margin-left: 8.4em;\n\t}\n\t.results__wrapper{  \n\t\twidth: 141.3em;\n\t\tmargin: 0;\n\t\tpadding-bottom: 0.125em;\n\t}\n\t.results .swiper-container{\n\t\tpadding: 0 93.375em 0 0;\n\t}\n\t.results .results__wrapper .swiper-container .swiper-wrapper{\n\t\ttransform: none !important;\n\t}\n\t.results .results__wrapper .swiper-container .swiper-wrapper .swiper-slide{\n\t\twidth: 100%;\n\t    padding: 0 16.5% 0 0;\n\t}\n\t.results__slide{\n\t\theight: 28.5em;\n\t\tmargin-bottom: 2.6em;\n\t\tborder-radius: 1em;\n\t}\n\t.swiper-slide{\n\t\ttransition: 0.3s !important;\n\t\topacity: 0.6; \n\t\tz-index: 0;\n\t\tpointer-events: none; \n\t} \n\t.swiper-slide-active{\n\t\tz-index: 2;\n\t\topacity: 1;\n\t\ttransform: none;\n\t\tpointer-events: all;\n\t}\n\t.swiper-slide-prev:nth-child(2),\n\t.swiper-slide-active:nth-child(2)+.swiper-slide,\n\t.swiper-slide-active:nth-child(2){\n\t\ttransform: translateX(-100%);\n\t}\n\t.swiper-slide-active:nth-child(3){\n\t\ttransform: translateX(-200%);\n\t}\n\t.results__slideTop{\n\t\theight: 3em;\n\t\tpadding: 0.2em 0.8em 0;\n\t}\n\t.tips__topAva{\n\t\twidth: 1.5em;\n\t    margin-right: 0.5em;\n\t}\n\t.tips__topName{\n\t\tletter-spacing: 0.03em;\n\t\tfont-size: 0.9375em;\n\t}\n\t.tips__topName svg{\n\t\tdisplay: none;\n\t}\n\t.tips__topSubs{\n\t\tfont-size: 0.8125em;\n\t\tmargin-top: -0.1em;\n\t}\n\t.results__slideMiddleTime{\n\t\tfont-size: 0.75em;\n\t\tline-height: 1.66;\n\t\tbottom: 0.85em;\n\t    right: 0.85em;\n\t    padding: 0 0.85em;\n\t}\n\t.results__slideMiddleMute{\n\t    bottom: 0.85em;\n    \tleft: 0.85em;\n    \twidth: 1.25em;\n    \theight: 1.25em;\n\t}\n\t.results__slideMiddlePlay{\n\t\twidth: 3.75em;\n\t\tmargin: -1.875em 0 0 -1.975em;\n\t\ttransition: 0.3s transform;\n\t}\n\t.results__slide:hover .results__slideMiddlePlay{\n\t\ttransform: scale(1.1);\n\t}\n\t.results__slideBottom{\n\t\theight: 3em; \n\t\tpadding: 0em 1em 0.9em;\n\t}\n\t.results__slideBottomText{\n\t\tfont-size: 1em;\n\t\tletter-spacing: 0;\n\t}\n\t.swiperArrow{\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 0;\n\t\tborder: none;\n\t\tmargin: 0;\n\t\tbackground: #fff;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 12.2em;\n\t\tz-index: 33;\n\t\ttransition: 0.3s background;\n\t\twidth: 4.3125em;\n\t\theight: 4.3125em;\n\t\tborder-radius: 100%;\n\t}\t\n\t.swiperArrow svg{\n\t\theight: auto;\n\t\twidth: 2.0625em;\n\t}\n\t.swiperArrow:hover{\n\t\tbackground: #9290FF;\n\t}\n\t.swiperArrow path{\n\t\ttransition: 0.3s fill;\n\t}\n\t.swiperArrow:hover path{\n\t\tfill: #fff;\n\t}\n\t.swiper-prev{\n\t\tmargin-left: -5.45em;\n\t}\n\t.swiper-next{\n\t\tmargin-left: 41.3em;\n\t}\n\t.results .swiper-container-horizontal>.swiper-pagination-bullets{\n\t\twidth: 40em;\n\t    bottom: 0.8em;\n\t}\n\t.results .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{\n\t\tbackground: #fff;\n\t\topacity: 0.4;\n\t\twidth: 0.51375em;\n\t\theight: 0.51375em;\n\t\tmargin: 0 0.61625em;\n\t} \n\t.results__bottomWrapper{\n\t\tflex-direction: row;\n\t\tmargin-top: 2.3em;\n\t}\n\t.results__teacher{\n\t\twidth: 7.5em;\n\t\tmargin: 0 1.85em 0 -0.3em;\n\t}\n\t.resultsBottom__leftText{\n\t\tfont-family: 'Roboto';\n\t\tletter-spacing: 0; \n\t\tpadding: 0;\n\t\tmargin: -0.65em 0 1.1em 0.1em;\n\t\tfont-size: 1.125em;\n\t\tline-height: 1.38;  \n\t\tmax-width: 33em;\n\t\ttext-align: left;\n\t}\n\t.resultsBottom__leftText span{\n\t\tdisplay: block;\n\t}\n\t.resultsBottom__btns{\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\twidth: 27.3em;\n\t}\n\t.resultsBottom__btns .btn{\n\t\theight: 3em;\n\t}\n\t.resultsBottom__btn--left{\n\t\twidth: 15.6875em;\n\t}\n\t.resultsBottom__btn--right{\n\t\twidth: 11em;\n\t\ttransition: 0.3s background, 0.3s border-color, 0.3s color;\n\t}\n\t.resultsBottom__btn--right:hover{\n\t\tbackground: #FF5317;\n\t\tborder-color: #FF5317;\n\t}\n\t.resultsBottom__btns .btn span{\n\t\tfont-size: 1em;\n\t}\n\t.resultsBottom__btns .btn>span span{\n\t\tdisplay: inline;\n\t}\n\t.results__social{\n\t\tposition: static;\n\t\tmax-width: 38.7em;\n\t}\n\t.resultsBottom__rightText{\n\t\tfont-family: 'Roboto';\n\t\tletter-spacing: 0; \n\t\tmargin: 0 0 1.25em;\n\t\tfont-size: 1em;\n\t\tline-height: 1.1875; \n\t}\n\t.social{\n\t\tpadding-right: 0.4em;\n\t}\n\t.social__link{\n\t\ttransition: 0.3s transform;\n\t\tmargin: 0 0 0 0.4375em;\n\t}\n\t.social__link:hover{\n\t\ttransform: scale(1.1);\n\t}\n}\n@media(min-width: 100vh) and (max-width: 145vh){ \n\t.results{\n\t\tfont-size: 1.0191vw;\n\t\theight: 100%;\n\t    align-items: center;\n\t    padding: 0 0 9em;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
